import React from 'react';
const emptyFn = () => 0;
const ToasterContext = React.createContext({ show: emptyFn, hide: emptyFn });
export default ToasterContext;
//# sourceMappingURL=ToasterContext.js.map